import { getGameSize } from '../../Config/Levels';
import { getRandom, getRandomFloat } from '../../Utils/Utils';
import { FallingParticle } from './FallingParticle';

/**
 * shows a bunch of confetti made out of pixi.graphics rectangles
 */
export class Confetti extends FallingParticle {
    constructor() {
        const getConfetti = () => {
            const h = 10;
            const w = 20;
            const colors = [0xf1e800, 0xf94628, 0x78f503, 0x30f3ff, 0xffefe8];
            const randomNum = getRandom(0, 4);
            const rect: PIXI.Graphics = this.drawRect(w, h, colors[randomNum]);
            rect.x = getRandomFloat(0, getGameSize().gameWidth);
            return rect;
        };
        super(getConfetti);
    }

    /**
     * creates a rectangle and caches it
     * @param w the width of the rectangle
     * @param h the hight of the rectangle
     * @param c the color of the rectangle
     */
    private drawRect(w: number, h: number, c: number) {
        const rect = new PIXI.Graphics();
        rect.beginFill(c);
        rect.drawRect(0, 0, w, h);
        rect.endFill();
        return rect;
    }
}
